import { MutableRefObject } from 'react';
import { NativeMethods } from 'react-native';

import { MeasureDimensionsType } from '@types';

export type MeasureLayoutOnSuccessType = (
  dimensions: MeasureDimensionsType,
) => void;
export type MeasureLayoutOnErrorType = () => void;

export function useMeasureLayout<
  TRef extends MutableRefObject<NativeMethods | null>,
  TContainerRef extends MutableRefObject<any>,
>(componentRef: TRef, containerRef: TContainerRef) {
  function measureLayout(
    onSuccess: MeasureLayoutOnSuccessType,
    onError?: MeasureLayoutOnErrorType,
  ) {
    if (componentRef.current && containerRef.current) {
      componentRef.current.measureLayout(
        containerRef.current,
        (
          left: number,
          top: number,
          width: number,
          height: number,
        ) => {
          onSuccess({
            width,
            height,
            top,
            left,
          });
        },
        () => {
          if (onError) {
            onError();
          }
        },
      );
    }
  }

  return measureLayout;
}
